var map = {
	"./aasimarevilquirk.json": "6d06",
	"./aasimargoodorevil.json": "63ab",
	"./aasimargoodquirk.json": "938a",
	"./abstractword.json": "f08c",
	"./age.json": "91bb",
	"./ageBonus.json": "536d",
	"./alignment.json": "2cef",
	"./aliment.json": "970c",
	"./amonster.json": "78ce",
	"./animaltat.json": "56c6",
	"./archdevil.json": "d7167",
	"./atattooadj.json": "d139",
	"./attractiveness.json": "106a",
	"./badfacemod.json": "bf75",
	"./badlooking.json": "4c1c",
	"./badsmell.json": "eff1",
	"./beard.json": "5ef9",
	"./beardlength.json": "8906",
	"./beardshape.json": "d18b",
	"./bodypart.json": "21fa",
	"./bodypart1.json": "d578",
	"./bodypart2.json": "203f",
	"./bodyparttat.json": "c575",
	"./brand.json": "108a",
	"./class.json": "30ba",
	"./collection.json": "4a72",
	"./color.json": "2a16",
	"./contest.json": "3cec",
	"./degree.json": "8e26",
	"./degree2.json": "bd9c",
	"./demongod.json": "2b0b",
	"./devilgod.json": "70e5",
	"./dragonborngender.json": "4051",
	"./dragonbornname.json": "ec75",
	"./dragongod.json": "826d",
	"./dragonhair.json": "3838",
	"./dragonquirks.json": "bdd3",
	"./dragons.json": "4d5c",
	"./dragonskin.json": "e00a",
	"./drowgod.json": "7052",
	"./drowquirks.json": "6479",
	"./dwarfgender.json": "5557",
	"./dwarfgod.json": "2523",
	"./dwarfquirks.json": "e2ef",
	"./dwarfsurname.json": "484a",
	"./elfgender.json": "ffe1",
	"./elfgod.json": "e451",
	"./elfquirks.json": "35c2",
	"./elfskin.json": "3970",
	"./elfsurname.json": "1b54",
	"./entertainer.json": "6eee",
	"./evilgod.json": "6cb6",
	"./evilworship.json": "6d8a",
	"./extrafinger.json": "445f",
	"./eyecolor.json": "f7cf",
	"./face.json": "9af7",
	"./faceshape.json": "f566",
	"./feathertexture.json": "4aed",
	"./female.json": "d79a",
	"./femaledwarfname.json": "2b0c",
	"./femaleelfname.json": "fd73",
	"./femalegnomename1.json": "a8f8",
	"./femalegnomename2.json": "e472",
	"./femalegnomename3.json": "0818",
	"./femalegnomename4.json": "85bb",
	"./femalehalflingname.json": "2f15",
	"./femalehumanname.json": "7009",
	"./femaleorcname.json": "0641",
	"./femaletritonname.json": "cebd",
	"./firbolgquirk.json": "112c",
	"./firbolgskin.json": "7e54",
	"./forcealign.json": "0241",
	"./frequency.json": "e500",
	"./furniture.json": "3992",
	"./gender.json": "26777",
	"./getevilgod.json": "44fc",
	"./gnomegender.json": "86ec",
	"./gnomegod.json": "9073",
	"./gnomequirks.json": "9721",
	"./goblinname.json": "b1d0",
	"./goliathadj.json": "d158",
	"./goliathanimalaction.json": "7553",
	"./goliathanimalnoun.json": "93a5",
	"./goliathcraftaction.json": "0c11",
	"./goliathcraftnoun.json": "6c78",
	"./goliathfightingaction.json": "cb60",
	"./goliathfightingnoun.json": "6ae9",
	"./goliathhair.json": "9c83",
	"./goliathmysticaction.json": "1b00",
	"./goliathmysticnoun.json": "a0cd",
	"./goliathname.json": "73c7",
	"./goliathnoun.json": "033b",
	"./goliathquirks.json": "538c",
	"./goliathtraits1.json": "3fec",
	"./goodface.json": "8cf1",
	"./goodfacemod.json": "b975",
	"./goodgod.json": "80db",
	"./goodlooking.json": "ce2b",
	"./goodorevil.json": "d020",
	"./goodsmell.json": "2389",
	"./hair.json": "0a6c",
	"./hairColor.json": "1ae0",
	"./hairLength.json": "6af7",
	"./hairType.json": "2944",
	"./halfelfgender.json": "a747",
	"./halfelfskin.json": "e027",
	"./halflinggender.json": "e0e8",
	"./halflinggod.json": "82f2",
	"./halflingsurname.json": "92d9",
	"./halforcgender.json": "04e5",
	"./halforcskin.json": "6d4e",
	"./halfquirks.json": "9e92",
	"./head.json": "65a5",
	"./height.json": "b235",
	"./hiCha.json": "f193",
	"./hiCon.json": "c930",
	"./hiDex.json": "e377",
	"./hiInt.json": "4170",
	"./hiStr.json": "b4ee",
	"./hiWis.json": "0569",
	"./highattractiveness.json": "f728",
	"./hooks.json": "35c9",
	"./hooks1.json": "b43a",
	"./hooks2.json": "aef7",
	"./humangender.json": "e845",
	"./humangod.json": "0705",
	"./humanskin.json": "107f",
	"./humansurname.json": "5302",
	"./inheritance.json": "6439",
	"./kenkucolor.json": "0bf2",
	"./kenkuname.json": "4a23",
	"./kenkunameanimal.json": "739a",
	"./kenkunamefighting.json": "054e",
	"./kenkunamemetal.json": "e290",
	"./kenkunamequiet.json": "4042",
	"./kenkuquirks.json": "440b",
	"./kenkuskin.json": "3fd9",
	"./language.json": "f865",
	"./learned.json": "cca8",
	"./lesserNobility.json": "069e",
	"./lightweight.json": "0d8e",
	"./lizardcolors.json": "0ed8",
	"./lizardgender.json": "5d94",
	"./lizardquirks.json": "44e5",
	"./lizardskin.json": "1af8",
	"./lizardtraits1.json": "2251",
	"./longbeard.json": "f81b",
	"./longbeard1.json": "491b",
	"./lowCha.json": "2b8b",
	"./lowCon.json": "1c75",
	"./lowDex.json": "f26c",
	"./lowInt.json": "6078",
	"./lowStr.json": "50ed",
	"./lowWis.json": "d24c",
	"./male.json": "4d63",
	"./maledwarfname.json": "ea59",
	"./maleelfname.json": "f17d",
	"./malegnomename1.json": "904e",
	"./malegnomename2.json": "710f",
	"./malegnomename3.json": "3174",
	"./malegnomename4.json": "77af",
	"./malehalflingname.json": "bde6",
	"./malehumanname.json": "32d5",
	"./maleorcname.json": "87a5",
	"./maletritonname.json": "3e0c",
	"./martial.json": "2fec",
	"./martialfinesse.json": "7cd8",
	"./martialranged.json": "c8c1",
	"./martialweapon.json": "0d36",
	"./medCha.json": "93a5d",
	"./medCon.json": "6dda",
	"./medDex.json": "eab2",
	"./medInt.json": "32c3",
	"./medStr.json": "a4ef",
	"./medWis.json": "aa1f",
	"./medusa.json": "822b",
	"./medusahair.json": "d4fd",
	"./medusaname.json": "7ef5",
	"./medusaveil.json": "34be",
	"./militaryquirk.json": "ecf0",
	"./missingeye.json": "7ec0",
	"./missingfingers.json": "3243",
	"./missinglimb.json": "e947",
	"./mod.json": "99dc",
	"./monster.json": "1d64",
	"./monster1.json": "e4ed",
	"./monster2.json": "e4fd",
	"./mundaneobject.json": "46c0",
	"./naturequirk.json": "55ae",
	"./nonhumanskin.json": "c071",
	"./normallooking.json": "8c87",
	"./occupation.json": "5410",
	"./orcgender.json": "3e6c",
	"./orcgod.json": "ae16",
	"./orcskin.json": "71cd",
	"./orcsurname.json": "d487",
	"./organisation.json": "bb48",
	"./orientation.json": "487e",
	"./personality.json": "17bf",
	"./petanimal.json": "17e7",
	"./petname.json": "fcc7",
	"./petname1.json": "77db",
	"./piercingnumber.json": "2260",
	"./poorquirk.json": "23e3",
	"./precious.json": "d790",
	"./preciousitem.json": "d8c8",
	"./profession.json": "d5d7",
	"./professional.json": "8f8e",
	"./quirks.json": "4f06",
	"./race.json": "12a4",
	"./raceallergy.json": "06b8",
	"./racedwarf.json": "5c2a",
	"./raceelf.json": "0185",
	"./racegnome.json": "544a",
	"./racehalfling.json": "b00b",
	"./randomquirks.json": "f9f0",
	"./randomtraits1.json": "6442",
	"./randomtraits2.json": "624d",
	"./relationship.json": "a325",
	"./relationshipstatus.json": "a53e",
	"./religiousquirk.json": "2b8b7",
	"./richquirk.json": "f181",
	"./rl.json": "dd71",
	"./rlb.json": "1d0e",
	"./scaletexture.json": "4aa0",
	"./simplefinesse.json": "6b04",
	"./simpleranged.json": "5cd7",
	"./simpleweapon.json": "b2aa",
	"./size.json": "73a0",
	"./skin.json": "2d51",
	"./skinTexture.json": "681d",
	"./skinTone.json": "2a83",
	"./snakecolor.json": "e314",
	"./specialphysical.json": "edf6",
	"./specialphysical1.json": "a7fc",
	"./specialphysical2.json": "757d",
	"./strongweight.json": "bfda",
	"./tabaxifirstname.json": "e784",
	"./tabaxilastname.json": "5d42",
	"./tabaxiname.json": "1906",
	"./tabaxinounname.json": "2ec6",
	"./tabaxinumbername.json": "9dbd",
	"./tabaxiobsession.json": "4cba",
	"./tabaxiquirks.json": "f9a6",
	"./tabaxiskin.json": "e6dd",
	"./tabaxiskincolor.json": "08e1",
	"./tabaxiskinpattern.json": "f475",
	"./tabaxiskintexture.json": "0b2e",
	"./tattoo.json": "b1fa",
	"./tattooadj.json": "a00e",
	"./tendencies.json": "da21",
	"./texttat.json": "8d02",
	"./tieflingevilname.json": "2871",
	"./tieflinggoodname.json": "b723",
	"./tieflinggoodorevil.json": "d7e7",
	"./tieflingname.json": "1897",
	"./tieflingneutralname.json": "a965",
	"./tieflingskin.json": "08c4",
	"./traits.json": "993c",
	"./tritongender.json": "cf2a",
	"./tritonhair.json": "7c06",
	"./tritonhaircolor.json": "5a33",
	"./tritonquirks.json": "a1ed",
	"./tritonskin.json": "6f95",
	"./tritonsurname.json": "e5f9",
	"./underclass.json": "6f64",
	"./weapon.json": "cd5b",
	"./weight.json": "781c",
	"./weirdQuirk.json": "39cf",
	"./werebeast.json": "6a56",
	"./whitehair.json": "12ad",
	"./workClass.json": "9812",
	"./worship.json": "cdb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "39dc";